import React from 'react'
import Slider from 'react-slick/lib/slider';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HomeMonthItem from './HomeMonthItem';
import { homeSliderMonth } from '../../../data/data';

export default function HomeMonthSlider() {

    // slider arrows is set custom style
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        draggable: false,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 3,
                }
            }
        ]
    };
    return (
        <div className='w-full  relative font-dropdownFont monthSlider'>
            <Slider {...settings}>
                {
                    homeSliderMonth &&
                    homeSliderMonth.map((item, i) => (
                        <HomeMonthItem data={item} key={item.id} />
                    ))
                }
            </Slider>
        </div >
    )
}
